import { render, staticRenderFns } from "./customColorComponents.vue?vue&type=template&id=47917d4e&scoped=true"
import script from "./customColorComponents.vue?vue&type=script&lang=js"
export * from "./customColorComponents.vue?vue&type=script&lang=js"
import style0 from "./customColorComponents.vue?vue&type=style&index=0&id=47917d4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47917d4e",
  null
  
)

export default component.exports